import styled, { css } from 'styled-components';
import { mediaQuery } from 'styles/helper';

export const BodyContainer = styled.tbody`
  border-top: 1px solid var(--border-secondary);
`;

interface RowContainerProps {
  templateColumns: string;
  columnCount: number;
}

export const RowContainer = styled.tr<RowContainerProps>`
  display: grid;
  grid-template-columns: ${({ templateColumns }) => templateColumns};

  ${({ columnCount }) =>
    mediaQuery(
      'md',
      css`
        display: grid;
        width: 100%;
        box-sizing: border-box;

        grid-template-columns: repeat(${columnCount - 1}, 1fr);
        grid-template-rows: repeat(2, auto);

        .title-cell {
          grid-area: 1 / 1 / 2 / ${columnCount};
        }
      `
    )}
`;
